<template>
  <div>
    <basic-customer-inquiry v-if="!isLaunchpack"></basic-customer-inquiry>

    <launchpack-customer-inquiry v-if="isLaunchpack"></launchpack-customer-inquiry>

  </div>
</template>

<script>
  import BasicCustomerInquiry from "./BasicCustomerInquiry";
  import LaunchpackCustomerInquiry from "./LaunchpackCustomerInquiry";

  export default {
    name: 'CustomerInquiry',
    components: {
      LaunchpackCustomerInquiry,
      BasicCustomerInquiry},
    data() {
      return {}
    },
    created(){
      /* 테이블, 필터를 구성할 structure_path, url을 파라미터로 넘겨준다.
      *  structure.js에 structure_path에 맞게 데이터를 생성한다.
      *  해당 url에 맞게 axios 호출이 잘되는지 확인한다.
      * */
      //this.initializing('launchpack_customer_inquiry', 'launchpack/inquiry/customer');

    }
  }
</script>

<style lang="stylus" type="stylus" scoped>

</style>
